// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper{width:100%!important}.Accordion{overflow:auto;height:80%;top:0;position:absolute;width:inherit;padding-right:6px;font-family:Open Sans}.centeredModalBody{width:600px;margin:0 auto}.btnAction{color:#fff;font-size:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
